import { USER_STATUS_TEXT } from '../../../constants/user'

export function getUserStatusColor(status) {
  return Number.isFinite(status) ? USER_STATUS_TEXT[status].color : null
}
